export default __webpack_public_path__ + "bde43b1238d68db7a00fb04294c8cebc.gif";